import { BasePlugin } from '../base'
import mdcIConToggle from './mdc-icon-toggle.vue'

export { mdcIConToggle }

export default BasePlugin({
  mdcIConToggle
})
